import { render, staticRenderFns } from "./NuestroProductos.vue?vue&type=template&id=67da7008&scoped=true&"
import script from "./NuestroProductos.vue?vue&type=script&lang=js&"
export * from "./NuestroProductos.vue?vue&type=script&lang=js&"
import style0 from "./NuestroProductos.vue?vue&type=style&index=0&id=67da7008&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67da7008",
  null
  
)

export default component.exports